import axios from 'axios';

export const FETCH_NEXT_PANEL_PAGE = 'FETCH_NEXT_PANEL_PAGE';
export const FETCH_PANEL = 'FETCH_PANEL';
export const SET_FIRST_PAGE = 'SET_FIRST_PAGE';
export const TOGGLE_PANEL_FETCHING = 'TOGGLE_PANEL_FETCHING';

export function fetchNextPanelPage(url, headers, panelId) {
  const request = axios.get(url, headers);
  return {
    type: FETCH_NEXT_PANEL_PAGE,
    payload: request,
    meta: { panelId },
  };
}

export function fetchPanel(url, headers, panelId) {
  const request = axios.get(url, headers);

  return {
    type: FETCH_PANEL,
    payload: request,
    meta: { panelId },
  };
}

export function setFirstPage(panelData, panelId) {
  return {
    type: SET_FIRST_PAGE,
    payload: panelData,
    meta: { panelId },
  };
}

export function toggleFetching(value) {
  return {
    type: TOGGLE_PANEL_FETCHING,
    payload: { value },
  };
}
